import React, { useState } from 'react';
import { useEnochFilterContext } from './context';
import { useEnochProfileConnectionStats } from '../../../query/enoch';
import { Card, Statistic, Spin, Modal } from 'antd';
import EnochProfileConnectionDetails from './EnochProfileConnectionDetails';

export default function EnochProfileConnectionStats() {
  const [showDetails, setShowDetails] = useState(false);
  const filter = useEnochFilterContext();
  const { data, isLoading } = useEnochProfileConnectionStats(filter);

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <Card onClick={() => setShowDetails(true)}>
          <Statistic
            precision={0}
            style={{ cursor: 'pointer', transition: 'background-color 0.3s' }}
            suffix="profiles"
            title="Disconnected Profiles / Total Profiles"
            value={`${data?.numOfDisconnectedProfiles ||
              0} / ${data?.totalProfiles || 0}`}
            valueStyle={{
              color: '#0047AB',
            }}
          />
        </Card>
      </Spin>

      <Modal
        footer={null}
        title="Disconnected Profiles"
        visible={showDetails}
        width="80%"
        onCancel={() => setShowDetails(false)}
      >
        <EnochProfileConnectionDetails />
      </Modal>
    </>
  );
}
